import { GenericPaginatedListResponse, GenericResponse } from './main'
import { MbtiPreQuestionAnswer, MbtiQuestionAnswer } from './mbti-question'
import { QuestionAnswer, QuestionGroup } from './question'
import { Profile } from './user'

// generic interfaces

export type QuizSubject = 'host' | 'guest'
/*
 * Generic quiz report interface (use this rather than below)
 */
export enum QuizReportType {
  MBTI = 'MBTI',
  MBTI_IDEAL_TYPE = 'MBTI_IDEAL_TYPE',
  IDEAL_TYPE = 'IDEAL_TYPE',
  MBTI_BEST_FRIEND = 'MBTI_BEST_FRIEND',
  FAVOUR_TOURNAMENT = 'FAVOUR_TOURNAMENT',
  THINKING_CHAIR = 'THINKING_CHAIR',
  ATTACHMENT_TYPE = 'ATTACHMENT_TYPE',
  IMAGE_GAME = 'IMAGE_GAME',
  GUESS_ME = 'GUESS_ME',
  SURVEY = 'SURVEY',
  GROUP_CHEMI = 'GROUP_CHEMI',
  SCHOO_IDEAL_TYPE = 'SCHOO_IDEAL_TYPE',
  DAILY_LOG_QUIZ = 'DAILY_LOG_QUIZ',
  HSP = 'HSP',
  SOULMATE = 'SOULMATE',
  EGEN_TETO = 'EGEN_TETO',
}

// quiz report url에 들어가는 string
export enum QuizReportUrlType {
  MBTI = 'mbti',
  FAVOUR_TOURNAMENT = 'favour-tournament',
  ATTACHMENT_TYPE = 'attachment-type',
  IMAGE_GAME = 'image-game',
  GUESS_ME = 'guess-me',
  SURVEY = 'survey',
  HSP = 'hsp',
  EGEN_TETO = 'egen-teto',
}

interface QuizReportBaseData {
  id?: number
  user?: number
  userId?: number
  userIdentifier?: string
  respondentLastName?: string
  respondentFirstName?: string
  profile?: Profile
  isProfileHidden: boolean
  type: QuizReportType
  answers: QuestionAnswer[]
  createdAt?: string
  isRemoved?: boolean
}

export interface QuizReportData extends QuizReportBaseData {
  questionGroup?: QuestionGroup
}

// quizreport post용 데이터
export interface QuizReportPostData extends QuizReportBaseData {
  questionGroup?: number
  relatedQuizReport?: number
  version?: number
}

export interface GuestQuizReportData extends QuizReportData {
  hostQuizReport: number
  matchRate?: number
}

export interface HostQuizReportData extends QuizReportData {}

export interface QuizReportResponse extends GenericResponse {
  data: QuizReportData
}

export interface HostQuizReportResponse extends QuizReportResponse {
  data: HostQuizReportData
}

export interface GuestQuizReportResponse extends QuizReportResponse {
  data: GuestQuizReportData
}

interface QuizAnswerPostBody {
  respondentFirstName?: string
  respondentLastName?: string
  preQuestionAnswers?: MbtiPreQuestionAnswer[]
  questionAnswers?: MbtiQuestionAnswer[]
  isProfileHidden?: boolean
}

interface GenericQuizReport {
  questionGroup?: QuestionGroup
  endResult?: string
  type?: QuizReportType
  createdAt?: string
}

export interface FriendQuizReport extends GenericQuizReport {
  id: number
  respondentFirstName: string
  myGuestQuizReportSummary?: {
    endResult: string
    matchRate: number
  }
}

export interface FriendQuizReportPaginatedListResponse extends GenericPaginatedListResponse {
  data: FriendQuizReport[]
}

// 이하 my interfaces

export interface MyHostQuizReport extends GenericQuizReport {
  id: number
  respondentFirstName: string
  totalCount: number
  profile: Profile | null
  isRemoved: boolean
}

export interface MyGuestQuizReport extends GenericQuizReport {
  id: number
  matchRate: number
  isRemoved: boolean
  profile: Profile | null // my profile
  respondentFirstName: string
  questionGroup: QuestionGroup
  hostQuizReport: {
    id: number
    isRemoved: boolean
    profile: Profile | null
    respondentFirstName: string
  }
}

export interface MyHostQuizReportPaginatedListResponse extends GenericPaginatedListResponse {
  data: MyHostQuizReport[]
}

export interface MyGuestQuizReportPaginatedListResponse extends GenericPaginatedListResponse {
  data: MyGuestQuizReport[]
}

export interface MyHostQuizAnswerPostBody extends QuizAnswerPostBody {
  relatedQuizReport?: number // 가장 최근 answer quiz_report id. 어떤 퀴즈를 통해 본인이 퀴즈를 생성했는지 추적하기 위함.
}

export interface MyGuestQuizAnswerPostBody extends QuizAnswerPostBody {
  userIdentifier?: string // 비회원일 경우 uuid 저장
  hostQuizReport?: number
}

// hostQuizReport의 answer
export interface HostQuizReportAnswer extends GuestQuizReportData {
  matchRate: number
}
// hostQuizReport detail의 guestQuizReport 목록
export interface GuestQuizReportPaginatedListResponse extends GenericPaginatedListResponse {
  data: HostQuizReportAnswer[]
}

export interface QuizReportRelationResponse extends GenericResponse {
  data: {
    relation: QuizReportRelation
  }
}

export enum QuizReportRelation {
  HOST = 'HOST',
  GUEST = 'GUEST',
  ANONYMOUS = 'ANONYMOUS',
}

export interface HostInfo {
  id: number
  userId: number
  isProfileHidden: boolean
  profile: Profile
  respondentFirstName: string
  answers: QuestionAnswer[]
  questionGroup: QuestionGroup
}

export interface HostInfoResponse {
  data: HostInfo
}
